import {Component, inject} from '@angular/core';
import {FormBuilder, ReactiveFormsModule, Validators} from '@angular/forms';
import {ActivatedRoute, RouterLink} from '@angular/router';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {TablerIconsModule} from 'angular-tabler-icons';
import {MaterialModule} from '@app/material.module';
import {environment} from '@environment/environment';
import {passwordStrengthValidator, passwordsMatchValidator} from '@core/shared/form-validators';
import {HttpClient} from '@angular/common/http';
import {apiErrorMessage} from '@services/api/admin/admin-api.service';

/** Pagina del link di invito: l'utente sceglie la password e l'account si attiva. */
@Component({
  selector: 'app-invite',
  standalone: true,
  imports: [ReactiveFormsModule, RouterLink, MaterialModule, TranslateModule, TablerIconsModule],
  templateUrl: './invite.component.html',
})
export class InviteComponent {
  private route = inject(ActivatedRoute);
  private http = inject(HttpClient);
  private translate = inject(TranslateService);
  private fb = inject(FormBuilder);

  readonly passwordMinLength = environment.password_min_length;
  private readonly uidb64 = this.route.snapshot.paramMap.get('uidb64') ?? '';
  private readonly token = this.route.snapshot.paramMap.get('token') ?? '';
  hidePassword = true;
  saving = false;
  done = false;
  error = '';

  form = this.fb.nonNullable.group({
    new_password1: ['', [Validators.required, Validators.minLength(this.passwordMinLength), passwordStrengthValidator()]],
    new_password2: ['', Validators.required],
  }, {validators: passwordsMatchValidator('new_password1', 'new_password2')});

  submit(): void {
    if (this.form.invalid) {
      return;
    }
    this.saving = true;
    this.error = '';
    const {new_password1, new_password2} = this.form.getRawValue();
    // HttpClient diretto: serve il dettaglio dell'errore (es. password troppo debole), che ApiService non restituisce
    const url = `${environment.api.base_url}/auth/password/reset/confirm/${this.uidb64}/${this.token}/`;
    this.http.post(url, {new_password1, new_password2, uidb64: this.uidb64, token: this.token}).subscribe({
      next: () => {
        this.saving = false;
        this.done = true;
      },
      error: (err) => {
        this.saving = false;
        // Token scaduto o gia' usato: i campi uidb64/token sono quelli in errore
        const body = err?.error?.data;
        const linkProblem = Array.isArray(body) && body.some((item: object) => 'token' in item || 'uidb64' in item);
        this.error = linkProblem
          ? this.translate.instant('invite.invalid_link')
          : apiErrorMessage(err, this.translate.instant('invite.invalid_link'));
      },
    });
  }
}
